import type { WidgetProps } from '@rjsf/utils';

import { TextWidget } from '../textWidget';

/**
 * If no UISchema is specified for this widget, it will default to
 * the checkbox widget styling.
 * If no enumNames property has been set in JSONSchema, it will default to 'yes' or 'no' values.
 */
export const Radio = ({ value = '', ...rest }: WidgetProps) => {
  const { enumOptions } = rest.options;
  const selectedOption = enumOptions?.find(
    option => option.value === value
  ) || {
    label: value
  };

  return <TextWidget value={selectedOption.label} {...rest} />;
};
